(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["australian-menopause-home-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (slider) => {
      if (slider.dataset.amv2Ready === 'true') return;
      const track = slider.querySelector('[data-amv2-track]');
      const slides = [...track.querySelectorAll('figure')];
      const previous = slider.querySelector('[data-amv2-prev]');
      const next = slider.querySelector('[data-amv2-next]');
      const status = slider.querySelector('[data-amv2-status]');
      if (!track || !slides.length || !previous || !next || !status) return;
      slider.dataset.amv2Ready = 'true';
      const step = () => slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      const update = () => {
        const current = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        status.textContent = `${String(current + 1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };
      previous.addEventListener('click', () => track.scrollBy({left:-step(),behavior:'smooth'}));
      next.addEventListener('click', () => track.scrollBy({left:step(),behavior:'smooth'}));
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        track.scrollBy({left:step() * (event.key === 'ArrowLeft' ? -1 : 1),behavior:'smooth'});
      });
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      update();
    };
    const all = (scope = document) => scope.querySelectorAll('[data-amv2-slider]').forEach(initialise);
    all();
    document.addEventListener('shopify:section:load', (event) => all(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["australian-menopause-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCommunitySlider = (slider) => {
      if (slider.dataset.amCommunityReady === 'true') return;

      const track = slider.querySelector('[data-am-community-track]');
      const slides = [...slider.querySelectorAll('.am-community__slide')];
      const previous = slider.querySelector('[data-am-community-prev]');
      const next = slider.querySelector('[data-am-community-next]');
      const status = slider.querySelector('[data-am-community-status]');
      if (!track || !slides.length || !previous || !next || !status) return;

      slider.dataset.amCommunityReady = 'true';
      let frame;

      const getStep = () => {
        const styles = window.getComputedStyle(track);
        return slides[0].getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
      };

      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const current = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / getStep())));
        status.textContent = `${String(current + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };

      const move = (direction) => track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll('[data-am-community-slider]').forEach(initialiseCommunitySlider);
    };

    initialiseAll();
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["australian-menopause-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-am-bundle-builder]').forEach((builder) => {
  const total = builder.querySelector('[data-am-bundle-total]');
  const button = builder.querySelector('[data-am-bundle-add]');
  const status = builder.querySelector('[data-am-bundle-status]');
  const optionalItems = Array.from(builder.querySelectorAll('[data-am-bundle-item]'));
  const variantSelect = document.querySelector('#am-variant-select');

  const formatMoney = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(cents / 100);

  const updateTotal = () => {
    const optionalTotal = optionalItems
      .filter((item) => item.checked)
      .reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
    total.textContent = formatMoney(Number(builder.dataset.currentPrice || 0) + optionalTotal);
  };

  optionalItems.forEach((item) => item.addEventListener('change', updateTotal));

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      builder.dataset.currentVariantId = option.value;
      if (option.dataset.price) builder.dataset.currentPrice = option.dataset.price;
      updateTotal();
    });
  }

  button.addEventListener('click', async () => {
    const items = [
      { id: Number(builder.dataset.currentVariantId), quantity: 1 },
      ...optionalItems
        .filter((item) => item.checked)
        .map((item) => ({ id: Number(item.value), quantity: 1 }))
    ];

    button.disabled = true;
    button.textContent = button.dataset.addingLabel;
    status.textContent = '';

    try {
      const response = await fetch(builder.dataset.addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(builder.dataset.cartUrl);
    } catch (error) {
      status.textContent = builder.dataset.errorLabel;
      button.disabled = false;
      button.textContent = button.dataset.defaultLabel;
    }
  });

  updateTotal();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
